"use strict";

exports.__esModule = true;
exports.AdvancedTimelineToggle = AdvancedTimelineToggle;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function AdvancedTimelineToggle(props) {
  var path = props.path,
    elementEditor = props.elementEditor,
    element = props.element,
    propName = props.propName,
    label = props.label;
  return /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: label,
    checked: element.props[propName],
    onChange: function onChange() {
      elementEditor.setProp(path, propName, !element.props[propName]);
    }
  });
}